(() => {
  const initializeGuide = (root = document) => {
    const guides = root.matches?.(".orbint-guide")
      ? [root]
      : root.querySelectorAll?.(".orbint-guide") ?? [];

    guides.forEach((guide) => {
      const comparisons = guide.querySelectorAll("[data-compare]");

      comparisons.forEach((compare) => {
        if (compare.dataset.orbintCompareReady === "true") return;

        const range = compare.querySelector(".compare-range");
        if (!range) return;

        const updateComparison = () => {
          compare.style.setProperty("--position", `${range.value}%`);
        };

        range.addEventListener("input", updateComparison);
        updateComparison();
        compare.dataset.orbintCompareReady = "true";
      });
    });
  };

  document.addEventListener("DOMContentLoaded", () => initializeGuide());

  if (document.readyState !== "loading") {
    initializeGuide();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initializeGuide(event.target);
  });
})();
